import React from 'react';
import { FileText } from 'lucide-react';
import { useIntersectionObserver } from '../hooks/useIntersectionObserver';

const pdfDocuments = [
  {
    id: 'it',
    lang: 'Italiano',
    flag: '🇮🇹',
    url: 'https://customer-assets.emergentagent.com/job_dp-landing/artifacts/68m4tuje_presentazione-italiano.pdf.pdf',
  },
  {
    id: 'en',
    lang: 'English',
    flag: '🇬🇧',
    url: 'https://customer-assets.emergentagent.com/job_dp-landing/artifacts/f095d869_presentazione-english.pdf.pdf',
  },
  {
    id: 'sl',
    lang: 'Slovenščina',
    flag: '🇸🇮',
    url: 'https://customer-assets.emergentagent.com/job_dp-landing/artifacts/jlx6yx8c_presentazione-slovenska.pdf.pdf',
  },
];

export const PDFViewerSection = () => {
  const [ref, isVisible] = useIntersectionObserver({ threshold: 0.1 });

  const handleOpenPdf = (pdfUrl) => {
    // Apri PDF in nuova scheda
    window.open(pdfUrl, '_blank');
  };

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-zinc-950 relative overflow-hidden">
      {/* Background pattern */}
      <div
        className="absolute inset-0 opacity-[0.02]"
        style={{
          backgroundImage:
            'radial-gradient(circle, rgba(255,255,255,0.1) 1px, transparent 1px)',
          backgroundSize: '30px 30px',
        }}
      ></div>

      <div className="container mx-auto max-w-6xl relative z-10">
        <div
          ref={ref}
          className={`transform transition-all duration-1000 ${
            isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
          }`}
        >
          {/* PDF Cards Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {pdfDocuments.map((pdf, index) => (
              <div
                key={pdf.id}
                className={`group cursor-pointer transform transition-all duration-700 delay-${
                  index * 100
                } ${
                  isVisible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0'
                }`}
                onClick={() => handleOpenPdf(pdf.url)}
              >
                <div className="bg-zinc-900 border border-zinc-800 hover:border-zinc-700 rounded-none p-6 sm:p-8 h-full transition-all hover:bg-zinc-800 hover:scale-105">
                  {/* Icon */}
                  <div className="flex items-center justify-center mb-6">
                    <div className="p-4 bg-white/5 rounded-none group-hover:bg-white/10 transition-all">
                      <FileText className="h-12 w-12 sm:h-16 sm:w-16 text-white" />
                    </div>
                  </div>

                  {/* Flag and Language */}
                  <div className="flex items-center justify-center gap-2 mb-4">
                    <span className="text-4xl">{pdf.flag}</span>
                  </div>

                  {/* Title */}
                  <h3 className="text-lg sm:text-xl font-bold text-white text-center mb-2">
                    {pdf.lang}
                  </h3>

                  {/* CTA */}
                  <p className="text-sm text-gray-500 text-center group-hover:text-gray-400 transition-colors">
                    Clicca per aprire →
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
